import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  pt: {
    translation: {
      common: {
        requiredField: 'Campo obrigatório',
        back: 'Voltar',
      },
      intro: {
        title: 'Faça parte da Sense Test!',
        subtitle: 'Experimente produtos nas nossas instalações ou no conforto de sua casa.',
        familyPartnership:
          'Tendo por base as suas raízes familiares, a Sense Test proporciona-lhe uma parceria que o envolve não só a si, como toda a sua família, desde as crianças aos seus animais de estimação. <strong>Todos podem provar connosco!</strong>',
        invitation:
          'Convidamo-lo a fazer parte da nossa base de provadores, pedindo-lhe que registe abaixo os seus dados. Assumimos um compromisso com os nossos consumidores, gratificando todos os estudos em que os mesmos participam.',
        opinion: 'Aqui a sua opinião importa!',
        next: 'AVANÇAR',
      },
      form: {
        title: 'Dados pessoais',
        labels: {
          name: 'Nome',
          city: 'Localidade',
          gender: 'Género',
          birthDate: 'Data de nascimento',
          position: 'Ocupação',
          mobile: 'Telefone',
          email: 'Email',
          dataProcessing: 'Tratamento dados',
          panel:'Painel'
        },
        placeholders: {
          fullName: 'Nome completo',
          year: 'Ano',
          month: 'Mês',
          day: 'Dia',
        },
        gender: {
          male: 'Masculino',
          female: 'Feminino',
        },
        months: {
          january: 'Janeiro',
          february: 'Fevereiro',
          march: 'Março',
          april: 'Abril',
          may: 'Maio',
          june: 'Junho',
          july: 'Julho',
          august: 'Agosto',
          september: 'Setembro',
          october: 'Outubro',
          november: 'Novembro',
          december: 'Dezembro',
        },
        invalidData:
          'Os dados indicados não são válidos. Pf tente novamente ou contacte a nossa equipa. Obrigado',
        consentRequired:
          'Para avançar, deverá dar o seu consentimento ao tratamento de dados. Obrigado',
        locationIntro:
          'A <strong>Sense Test</strong> tem duas salas de prova, em <porto>Porto</porto> e <torresVedras>Torres Vedras</torresVedras>, onde poderá deslocar-se para realizar provas e levantar amostras. Indique a mais próxima da sua residência.',
        locations: {
          porto: 'Porto',
          torresVedras: 'Torres Vedras',
          painelElectronico:'E-panel'
        },
        consent:
          'Aceito a utilização dos meus dados de acordo com o Regulamento Geral de Proteção de Dados (UE) 2016/679',
        submit: 'Registar',
      },
      message: {
        title: 'Obrigado!',
        social: 'Siga-nos nas redes sociais!',
      },
      footer: {
        developedBy: 'desenvolvido por',
      },
    },
  },
  en: {
    translation: {
      common: {
        requiredField: 'Required field',
        back: 'Back',
      },
      intro: {
        title: 'Join Sense Test!',
        subtitle: 'Try products at our facilities or from the comfort of your home.',
        familyPartnership:
          'Inspired by its family roots, Sense Test offers you a partnership that involves not only you, but your whole family, from children to pets. <strong>Everyone can test with us!</strong>',
        invitation:
          'We invite you to join our tester database by registering your details below. We are committed to rewarding consumers for every study they take part in.',
        opinion: 'Your opinion matters here!',
        next: 'CONTINUE',
      },
      form: {
        title: 'Personal details',
        labels: {
          name: 'Name',
          city: 'City',
          gender: 'Gender',
          birthDate: 'Date of birth',
          position: 'Occupation',
          mobile: 'Phone',
          email: 'Email',
          dataProcessing: 'Data processing',
          panel:'Panel'
        },
        placeholders: {
          fullName: 'Full name',
          year: 'Year',
          month: 'Month',
          day: 'Day',
        },
        gender: {
          male: 'Male',
          female: 'Female',
        },
        months: {
          january: 'January',
          february: 'February',
          march: 'March',
          april: 'April',
          may: 'May',
          june: 'June',
          july: 'July',
          august: 'August',
          september: 'September',
          october: 'October',
          november: 'November',
          december: 'December',
        },
        invalidData:
          'The provided details are not valid. Please try again or contact our team. Thank you.',
        consentRequired:
          'To continue, you must consent to the processing of your data. Thank you.',
        locationIntro:
          '<strong>Sense Test</strong> has two testing rooms, in <porto>Porto</porto> and <torresVedras>Torres Vedras</torresVedras>, where you can attend testing sessions and collect samples. Please choose the one closest to your residence.',
        locations: {
          porto: 'Porto',
          torresVedras: 'Torres Vedras',
          painelElectronico:'E-panel'
        },
        consent:
          'I agree to the use of my data in accordance with the General Data Protection Regulation (EU) 2016/679',
        submit: 'Register',
      },
      message: {
        title: 'Thank you!',
        social: 'Follow us on social media!',
      },
      footer: {
        developedBy: 'developed by',
      },
    },
  },
};

const supportedLanguages = ['pt', 'en'];
const queryLanguage = new URLSearchParams(window.location.search).get('lang');
const browserLanguage = navigator.language?.split('-')[0] ?? 'pt';
const lng = supportedLanguages.includes(queryLanguage)
  ? queryLanguage
  : supportedLanguages.includes(browserLanguage)
    ? browserLanguage
    : 'pt';

i18n.use(initReactI18next).init({
  resources,
  lng,
  fallbackLng: 'pt',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
